import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

//thema
import { ConfigProvider } from 'antd';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const theme = {
  token: {
    colorPrimary: '#ee2b6c',

  },
  components: {
    Segmented: {
      itemSelectedBg:"#3474e2"
      /* here is your component tokens */
    },
  },
};

root.render(
  <React.StrictMode>
    <ConfigProvider theme={theme}>
      <App />
    </ConfigProvider>
  </React.StrictMode>
);
